import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Loading from "../LoadingError/Loading";
import Message from "../LoadingError/Error";
import Blog from "../blogs/Blog";
import ReactPaginate from "react-paginate";
import { listBlogs } from "../../Redux/Actions/BlogAction";
import { Button, Heading } from "@chakra-ui/react";

const MainBlogs = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const blogList = useSelector((state) => state.blogList);
  const { loading, error, blog, totalPages, currentPage } = blogList;

  const blogDeleted = useSelector((state) => state.blogDeleted);
  const { error: errorDelete, success: successDelete } = blogDeleted;

  useEffect(() => {
    dispatch(listBlogs(page));
  }, [dispatch, successDelete, page]);

  const handlePageClick = (event) => {
    setPage(event.selected + 1);
  };

  return (
    <>
      <section className="content-main">
        <div className="content-header">
          <Heading as="h2" size="lg" color="teal.600">
            Blogs
          </Heading>
          <div>
            <Button as={Link}
              to="/addblog" type="submit" colorScheme="teal" _hover={{
                backgroundColor: "teal.600",
                color: "white",
              }}>
              Create New
            </Button>
          </div>
        </div>

        <div className="card mb-4 shadow-sm">
          <header className="card-header bg-white">
            <div className="row gx-3 py-3">
              <div className="col-lg-4 col-md-6 me-auto">
                <input
                  type="search"
                  placeholder="Search..."
                  className="form-control p-2"
                />
              </div>
            </div>
          </header>

          <div className="card-body">
            {errorDelete && <Message variant="alert-danger">{errorDelete}</Message>}
            {loading ? (
              <Loading />
            ) : error ? (
              <Message variant="alert-danger">{error}</Message>
            ) : (
              <div className="row">
                {blog.map((blog) => (
                  <Blog blog={blog} key={blog.id} />
                ))}
              </div>
            )}

            <ReactPaginate
              previousLabel={"previous"}
              nextLabel={"next"}
              breakLabel={"..."}
              pageCount={totalPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-center"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
              renderOnZeroPageCount={null}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default MainBlogs;
